import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { defineComponent, inferProps, useOnInput, type ReactiveComponent } from "vue-utils"
import Icon from "./Icon"

interface Props {
	search: string
	setSearch(search: string): void
}

const SearchBar: ReactiveComponent<Props> = (props) => {
	return () => (
		<div class="flex items-center spacing-2 w-full">
			<Icon icon={faSearch} />
			<label class="flex-grow-1">
				<input
					class="w-full"
					type="search"
					value={props.search}
					onInput={useOnInput(props.setSearch)}
					placeholder="Type to search..."
				/>
			</label>
		</div>
	)
}

export default defineComponent(SearchBar, inferProps<Props>())
